export const routeNameMiddleApp = 'middlePageOpenApp';

export const routeNameOpenUrl = 'middlePageOpenUrl';
